import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { headingStyle } from '../../../../play-core/styles/heading-style';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { ToggleActionIcon } from '../../components/Teaser/TeaserActions/ToggleActionIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ActionTitle = ({
  title,
  onAction,
  ariaIconTitle,
  isActive,
  activeIcon,
  inactiveIcon,
  showAction = true
}) => /*#__PURE__*/_jsxs(StyledActionTitle, {
  children: [showAction && /*#__PURE__*/_jsx(ToggleActionIcon, {
    isHovering: true,
    onClick: onAction,
    activeIcon: activeIcon,
    ariaTitle: ariaIconTitle,
    inactiveIcon: inactiveIcon,
    isActive: isActive,
    withOuterPadding: false
  }), /*#__PURE__*/_jsx(Title, {
    children: title
  })]
});
export const Title = styled.h1.withConfig({
  displayName: "ActionTitle__Title",
  componentId: "sc-1g0pzdy-0"
})(["color:", ";margin:0 0 0 0;line-height:24px;", ";", "{line-height:34px;}", "{line-height:40px;}"], Colors.WHITE, headingStyle, Viewports.for('large'), Viewports.for('xLargeUp'));
const StyledActionTitle = styled.div.withConfig({
  displayName: "ActionTitle__StyledActionTitle",
  componentId: "sc-1g0pzdy-1"
})(["align-items:center;display:inline-grid;grid-column-gap:16px;grid-auto-flow:column;", "{grid-column-gap:12px;}"], Viewports.for('small'));